async function setAreaForm(prefectureId) {
  const areaSelect = document.getElementById("area_id");

  if (!prefectureId) {
    areaSelect.disabled = true;
    areaSelect.innerHTML = "<option value=''>エリアを選ぶ</option>"
    return;
  }

  const res = await fetch(`/anymarry_place_prefectures/${prefectureId}`);
  const json = await res.json();
  document.getElementById("region_or_style_id").dataset.region_or_style_id = json.region_id;
  const areaIdParam = document.getElementById("area_id_param").dataset.areaId
  areaSelect.disabled = false;
  let options = "";
  json.areas.forEach((area) => {
    const areaId = `a${area.area_id}`;
    const disabledOpt = area.count <= 0 ? "disabled" : "";
    const selectedOpt = areaId === areaIdParam ? "selected" : "";
    options += `<option value="${areaId}" ${disabledOpt} ${selectedOpt}>${area.name}</option>`
  });
  areaSelect.innerHTML = options;
}

window.addEventListener("pageshow", () => {
  const prefectureId = document.getElementById("prefecture_id").value;
  setAreaForm(prefectureId);
});

document.getElementById("prefecture_id").onchange = async (e) => {
  setAreaForm(e.target.value);
}

const styleIdElement = document.getElementById("style_id");
if (styleIdElement) {
  styleIdElement.onchange = async (e) => {
    const style_id = e.target.value;
    const has_meal_style = style_id === "wedding_reception" || style_id === "wedding_party";
    const meal_style_select = document.getElementById("meal_style_id");
    meal_style_select.disabled = !has_meal_style
  }
}

document.getElementById("search_submit").onclick = (e) => {
  e.preventDefault();
  let url = document.getElementById("search_form").action;
  const region_or_style_id = document.getElementById("region_or_style_id").dataset.region_or_style_id;
  if (region_or_style_id) {
    url = url + `/${region_or_style_id}`
  }

  const prefecture_id = document.getElementById("prefecture_id").value;
  if (prefecture_id) {
    url = url + `/${prefecture_id}`;

    const area_id = document.getElementById("area_id").value;
    if (area_id) {
      url = url + `/${area_id}`;
    }
  }

  if (document.getElementById("style_id")) {
    const style_id = document.getElementById("style_id").value;
    if (style_id) {
      const meal_style_id = document.getElementById("meal_style_id").value;
      if (meal_style_id) {
        url = `${url}?style_id=${style_id}&meal_style_id=${meal_style_id}`
      } else {
        url = `${url}?style_id=${style_id}`
      }
    }
  }

  window.location.href = url;
}
